import { FC, useCallback, useEffect, useState } from 'react';

import { useRequestCancel } from 'hooks/common/useRequestCancel';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import EditingActsTable from 'components/Admin/Reports/ActsReport/EditingActsTable/EditingActsTable';
import { fetchActs } from 'components/Admin/Reports/ActsReport/fetchActs';
import InputAccountId from 'components/Admin/Reports/ActsReport/Filter/InputAccountId/InputAccountId';
import InputEmployerId from 'components/Admin/Reports/ActsReport/Filter/InputEmployerId/InputEmployerId';
import SelectAdvertisingServiceType from 'components/Admin/Reports/ActsReport/Filter/SelectAdvertisingServiceType';
import SelectProcessingType from 'components/Admin/Reports/ActsReport/Filter/SelectProcessingType';
// @ts-expect-error no ts types
import SelectType from 'components/Admin/Reports/ActsReport/Filter/SelectType';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';

import { resetFilters, setDates } from 'store/models/acts';
import { useDispatch, useSelector } from 'store/utils';

const EditingActs: FC = () => {
    const isLoad = useSelector((state) => state.acts.isLoad);
    const { from, to } = useSelector((state) => state.acts);

    const [isReportFetched, setIsReportFetched] = useState(false);

    const dispatch = useDispatch();
    const { abortRequest, abortSignal } = useRequestCancel();

    useEffect(() => {
        dispatch(resetFilters());
    }, [dispatch]);

    const onClickSearch = () => {
        setIsReportFetched(true);
        abortRequest();
        void dispatch(fetchActs(true, abortSignal()));
    };

    const setDatesForMultiDatePicker = useCallback(
        (from: Date, to: Date) => {
            dispatch(setDates({ from, to }));
        },
        [dispatch]
    );

    return (
        <ReportWrapper
            filter={
                <>
                    <InputWithMultiDatePicker from={from} to={to} action={setDatesForMultiDatePicker} />
                    <SelectAdvertisingServiceType />
                    <SelectProcessingType />
                    <SelectType />
                    <InputEmployerId />
                    <InputAccountId />
                </>
            }
            content={isReportFetched && <EditingActsTable />}
            isLoadContent={isLoad}
            onClickSearch={onClickSearch}
            onClickClear={() => dispatch(resetFilters())}
        />
    );
};

export default EditingActs;
